import Header from './compontents/Header';

import {Link as DomLink, Outlet, useLocation, useNavigate} from 'react-router-dom';
import Foorer from './compontents/Footer';
function AppLayout() {
    return (
        <>
       <Header></Header>
        <Outlet/>
            <Foorer></Foorer>
        </>

    );
}


export default AppLayout;